import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import emailjs from '@emailjs/browser'
import ReCAPTCHA from 'react-google-recaptcha'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [captchaValue, setCaptchaValue] = useState(null)
  const refForm = useRef()
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID
  const userToken = process.env.REACT_APP_EMAILJS_USER_TOKEN
  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    if (!captchaValue) {
      alert('Please verify that you are not a robot.')
      return
    }
    emailjs.sendForm(serviceId, templateId, refForm.current, userToken).then(
      () => {
        alert('Message successfully sent!')
        window.location.reload(false)
      },
      () => {
        alert('Failed to send the message, please try again')
      }
    )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', '', 'm', 'e']}
              idx={10}
            />
          </h1>
          <p>
            I'm currently a Computer Science student looking for a student
            position in backend or fullstack development. I'm eager to gain
            hands-on experience and contribute to meaningful projects. However,
            I'm also open to other opportunities where I can learn, grow, and
            make an impact - so feel free to reach out using the form below.
          </p>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/yoav-shenkerman"
            >
              <FontAwesomeIcon icon={faLinkedin} color="#59595a" />
            </a>
          </li>
        </div>
        <div className="contact-form">
          <form ref={refForm} onSubmit={sendEmail}>
            <ul>
              <li className="half">
                <input type="text" name="name" placeholder="Name" required />
              </li>
              <li className="half">
                <input type="email" name="email" placeholder="Email" required />
              </li>
              <li>
                <input
                  placeholder="Subject"
                  type="text"
                  name="subject"
                  required
                />
              </li>
              <li>
                <textarea
                  placeholder="Message"
                  name="message"
                  required
                ></textarea>
              </li>
              <li className="captcha-submit">
                <ReCAPTCHA
                  sitekey={recaptchaKey}
                  onChange={(value) => setCaptchaValue(value)}
                />
                <button type="submit" className="flat-button">
                  SEND
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  )
}

export default Contact
